import React from 'react';
import { authRoles } from 'app/auth';

const EmailCmsConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	auth: authRoles.superAdmin,
	routes: [
		{
			path: '/email-cms',
			component: React.lazy(() => import('./EmailCms'))
		}
	]
};

export default EmailCmsConfig;
